import { NodeInterface } from "@swivl-mono/types";

import { FaMinusCircle } from "react-icons/fa";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import { RandomId } from "@swivl-mono/helpers";

const Random = {
  Type: "random",
  Empty: function() {
  let data = {
      "id": RandomId(6),
      "type": Random.Type,
      "delay": 0,
      "showTyping":false,
      "paths" :[ {"id":  RandomId(6),
                  "probability": 50,
                  "onCompleteGoto": null},
                  {"id": RandomId(6),
                  "probability": 50,
                  "onCompleteGoto": null}
               ]
             }
      return data;
    },

    PlumbData: function(node:NodeInterface) {
      let tabs:any = []
      if (node.paths) {
        for (var i = 0; i < node.paths.length; i++) {
          let path = node.paths[i];
            tabs.push({
              "id":  "paths_" + path.id,
              "source": "paths_" + i + "_onCompleteGoto",
              "target": path.onCompleteGoto,
              title:path.probability + "%",
            })
          
    
        }
      }
      return TabNodeLayoutData({
        node: node,
        title:"Random",
        baseWidth: 130,
        tabs:tabs
      });
    },

    InspectorPanel: class RandomInspectorPanel extends NodePanel{
      constructor(props:any) {
        super(props);
        this.addPath = this.addPath.bind(this)
        this.deletePressed = this.deletePressed.bind(this)
      }

      deletePressed(event:any) {this.deleteValue("paths", event.target.id)}

      addPath() {
        let pathData = {"id":  RandomId(6),
                        "probability": 0,
                        "onCompleteGoto": null}
        this.addItemToArray(pathData, "paths", true)
      }

        render() {
          var self = this;
            let pathViews;
            if (this.props.node.paths) {

              pathViews = this.props.node.paths.map(function(item:any,index:any) {
                var indexDisplay = index + 1;
                var keyName = "paths." + index + ".probability";
                return <div className="probabilityInput" key={index}>
                  <div>Chance for path {indexDisplay}:</div>
                  <input type="number" value={item.probability} onChange={self.onChangeCalculateOdds} name={keyName} id={item.id} className="pathChanceInput"/>%
                  <span className="deleteButtonIcon" onClick={self.deletePressed} id={index}><FaMinusCircle /></span>
                </div>
              });
            }
            return (<div>
              <div className="panel random_panel">
                <InspectorNodeHeader title="Random" />
                <div className="pathsList">
                  {pathViews}
                  <div className="addElementButton" onClick={this.addPath} >+ ADD PATH</div>
                  <div className="carouselPadding">.</div>
                </div>
              </div>
            <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
          </div>);
         }
       }
}
export default Random;
